import { render } from "./kaihuQuery.vue?vue&type=template&id=e74d704a&scoped=true"
import script from "./kaihuQuery.vue?vue&type=script&lang=js"
export * from "./kaihuQuery.vue?vue&type=script&lang=js"

import "./kaihuQuery.vue?vue&type=style&index=0&id=e74d704a&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e74d704a"]])

export default __exports__